import React from 'react';
import { PropTypes } from 'prop-types';
import VisitCard from './VisitCard';

const VisitCards = ({ visits, isLoading }) => {
  if (isLoading || visits.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="grid justify-start grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-6 gap-x-6 gap-y-8">
        {visits.map(visit => (
          <VisitCard
            key={visit.id}
            visit={visit}
          />
        ))}
      </div>
    </div>
  );
};

VisitCards.propTypes = {
  visits: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default VisitCards;
